import React from 'react';
import FAQBase from './FAQBase';

const questions = [
  {
    question: 'What does "incapacitated" or "too sick" mean?',
    answer:
      "While the meaning of these terms is often determined using standards described in your documents and applicable state law, 'incapacitated' or 'too sick' generally means you are unable to make or communicate your own decisions. This may be determined by one or more licensed physicians.",
  },
  {
    question: 'What does it mean to "quicken" or "hasten" death?',
    answer: 'To "quicken" or "hasten" death means taking action that may speed up death.',
  },
  {
    question:
      'If someone named in my documents moves or changes their name after becoming married, do I need to update the information?',
    answer:
      "Minor changes, such as a new address or last name, do not always require document updates, but it's a good idea to review your plan periodically to make sure it still clearly identifies the intended person. You can come back to update your estate plan online as needed.",
  },
];

const HealthCareFAQ = () => <FAQBase questions={questions} />;

export default HealthCareFAQ;
